import axios from 'axios';
import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import $ from 'jquery'
import MainLogo from '../mainassets/mainlogo.jpeg'
import NewLogo from 'src/assets/images/Connect2MedLogo.png'

import { Input, Button } from 'antd'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons'

export default function ForgotPassword() {
  let myStyle_otp = {
    display: 'none',
    backgroundColor: '#e1eaf0',
    width: 315,
  }
  const navigate = useNavigate()
  const [user_id, setUser_id] = useState('')
  const [contact_no, setContact_No] = useState('')
  const [otp, setOtp] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [msg, setMsg] = useState('')
  const [OTPValue, setOTPValue] = useState('')
  const [IsDisplayOTP, setIsDisplayOTP] = useState(false)
  const [OTP, setOTP] = useState(new Array(6).fill(''))
  const [isShowCurrentOTP, setIsShowCurrentOTP] = useState(false)
  const [isHideSubmitButton, setIsHideSubmitButton] = useState(false)
  const [isResetFunctionSectionOpen, setIsResetFunctionOpen] = useState(false)
  const [password, setPassword] = useState('')
  const [confirm_password, setconfirm_password] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const isHealthConnectPro = window.location.href.toLowerCase().includes('healthconnectpro')
  const logoSrc = isHealthConnectPro ? MainLogo : NewLogo
  const brandName = isHealthConnectPro ? 'HealthConnectPro' : 'Connect2Med'

  const handleChange = (element, index) => {
    console.log(element.value)

    if (isNaN(element.value)) return false
    setOTP([...OTP.map((d, idx) => (idx === index ? element.value : d))])
    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus()
    }
  }

  const onuser_idChange = (e) => {
    setUser_id(e.target.value)
  }
  const onContactChange = (e) => {
    setContact_No(e.target.value)
  }

  const onPasswordChange = (e) => setPassword(e.target.value)
  const onConfirmPasswordChange = (e) => setconfirm_password(e.target.value)

  const onsubmitform_otp = (e) => {
    e.preventDefault()
    setErrorMessage('')
    if (OTP.join('') != '') {
      console.log('if')

      if (OTP.join('') === OTPValue) {
        // navigate("/ResetPassword");
        setIsResetFunctionOpen(true)
      } else {
        setErrorMessage('Invalid OTP!')
        setIsResetFunctionOpen(false)
      }
    } else {
      console.log('else')
      setErrorMessage('Please give OTP')
    }
  }
  const location = useLocation()
  console.log(location.state)

  const onsubmitresend_otp = (e) => {
    axios.get(`${global.baseUrl}/api/common/Misc/sendotp?phone=${contact_no}&MDT=CP`)
      .then((OTPresponse) => {
        console.log('sendOTPHandler:otp response \n', OTPresponse.data)
        if (OTPresponse.data) {
          // console.log(OTPresponse.data.)
          if (OTPresponse.data.OTP_SMS_RESPONSE == 'No') {
            setIsDisplayOTP(true)
            setIsShowCurrentOTP(true)
            document.getElementById('forgot_password_div').style.display = 'none'
            document.getElementById('otp').style.display = 'block'
            navigate('/ForgotPassword')

            setOTPValue(OTPresponse.data.OTP)
            localStorage.setItem('temp_user_id', user_id)
          } else {
            setIsShowCurrentOTP(false)
            setIsDisplayOTP(false)
            setOTPValue(OTPresponse.data.OTP)
            localStorage.setItem('temp_user_id', user_id)
          }
        }
      })
      .catch((err) => {
        console.log(' otp send failed', err)
      })
  }

  const onsubmitform = (e) => {
    setIsHideSubmitButton(true)
    setMsg('')
    e.preventDefault()
    let formdata = $(e.target)
    formdata = new FormData()
    formdata.append('user_id', user_id)
    formdata.append('contact_no', contact_no)
    formdata.append('loggedin_user_id', localStorage.getItem('user_id'))
    $.ajax({
      type: 'POST',
      url: `${global.baseUrl}/api/common/Login/forgot_password`,
      data: formdata,
      processData: false,
      contentType: false,
      success(data) {
        console.log(data)
        if (data === 'success') {
          setIsHideSubmitButton(false)

          axios.get(`${global.baseUrl}/api/common/Misc/sendotp?phone=${contact_no}&MDT=CP`)
            .then((OTPresponse) => {
              console.log('sendOTPHandler:otp response \n', OTPresponse.data)
              if (OTPresponse.data) {
                // console.log(OTPresponse.data.)
                if (OTPresponse.data.OTP_SMS_RESPONSE == 'No') {
                  setIsDisplayOTP(true)

                  document.getElementById('forgot_password_div').style.display = 'none'
                  document.getElementById('otp').style.display = 'block'
                  navigate('/ForgotPassword')
                  setIsShowCurrentOTP(true)

                  setOTPValue(OTPresponse.data.OTP)
                  localStorage.setItem('temp_user_id', user_id)
                } else {
                  document.getElementById('forgot_password_div').style.display = 'none'
                  document.getElementById('otp').style.display = 'block'
                  navigate('/ForgotPassword')
                  setIsShowCurrentOTP(false)
                  localStorage.setItem('temp_user_id', user_id)
                  setOTPValue(OTPresponse.data.OTP)

                  setIsDisplayOTP(true)
                }
              }
            })
            .catch((err) => {
              console.log(' otp send failed', err)
              setIsHideSubmitButton(false)
            })
        } else {
          setMsg('User id or contact no does not match.')
          setIsHideSubmitButton(false)
        }
      },
      error: function (err) {
        console.log(err)
      },
    })
  }

  const onSubmitResetForm = (e) => {
    $('Button#submitbutton').css('display', 'none')
    setErrorMessage('')
    e.preventDefault()
    if (password === confirm_password) {
      let formdata = $(e.target)
      formdata = new FormData()
      formdata.append('password', password)
      formdata.append('confirm_password', confirm_password)
      formdata.append('user_id', localStorage.getItem('temp_user_id'))
      formdata.append('loggedin_user_id', localStorage.getItem('user_id'))
      $.ajax({
        type: 'POST',
        url: `${global.baseUrl}/api/common/Login/reset_password_clinic`,
        data: formdata,
        processData: false,
        contentType: false,
        success(data) {
          console.log(data)
          if (data === 'success') {
            setSuccessMessage('Updated Successfully redirecting to Login page')
            setTimeout(() => {
              navigate("/login");
            }, 3000)
          }
        },
        error: function (err) {
          console.log(err)
          $('Button#submitbutton').css('display', 'block')
        },
      })
    } else {
      $('Button#submitbutton').css('display', 'block')
      setErrorMessage('Password and Confirm Password must be same')
    }
  }

  const goToLogin = () => {
    navigate('/login');
  };

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }}>
        <div className="col-lg-4">
          <div className="content-area-card">
            <div
              className="card-innr card-innr-fix"
              id="forgot_password_div"
              style={{ backgroundColor: '#e1eaf0', width: '100%' }}
            >
              <div className="card-head" style={{ textAlign: 'center' }}>
                <img
                  className="image"
                  src={logoSrc}
                  style={{ height: 100, width: 100, paddingTop: 10 }}
                />
                <h6
                  className="card-title"
                  style={{ marginTop: 15, fontWeight: 'bold', fontSize: 18 }}
                >
                  Forgot Password
                </h6>
                <p className="card-title" style={{ marginTop: 1, color: 'black', fontWeight: 400 }}>
                  {location.state == 'doctor' ? 'Doctor@' : location.state === 'clinic' ? 'Clinic@' : ''} {brandName}
                </p>
              </div>

              <div style={{ textAlign: 'left' }} className="input-item input-with-label">
                <label
                  htmlFor="user_id"
                  className="col-form-label"
                  style={{
                    fontSize: 15,
                    color: '#7781A9',
                    textAlign: 'left',
                    marginLeft: 25,
                    marginBottom: 0,
                  }}
                >
                  {' '}
                  User Id *
                </label>

                <br />
                <input
                  style={{
                    border: '1px solid gray',
                    height: 40,
                    paddingLeft: 8,
                    marginLeft: 25,
                    fontSize: 9,
                    borderRadius: 4,
                    fontSize: 'small',
                    width: '90%',
                  }}
                  type="text"
                  name="user_id"
                  required
                  placeholder="User ID"
                  className="input-bordered"
                  value={user_id}
                  onChange={onuser_idChange}
                  maxLength={15}
                />
              </div>
              <div style={{ textAlign: 'left' }} className="input-item input-with-label">
                <label
                  htmlFor="password"
                  className="col-form-label"
                  style={{
                    fontSize: 15,
                    color: '#7781A9',
                    textAlign: 'left',
                    marginLeft: 25,
                    marginBottom: 0,
                  }}
                >
                  Contact No *
                </label>

                <input
                  style={{
                    border: '1px solid gray',
                    height: 40,
                    paddingLeft: 8,
                    marginLeft: 25,
                    fontSize: 9,
                    borderRadius: 4,
                    fontSize: 'small',
                    width: '90%',
                  }}
                  type="text"
                  name="contact_no"
                  autocomplete="off"
                  required
                  placeholder="Contact No."
                  className="input-bordered"
                  value={contact_no}
                  onChange={onContactChange}
                  maxLength={10}
                />
              </div>

              <br />
              {msg ? (
                <p style={{ fontSize: 14, fontWeight: 'bold', color: 'red', marginLeft: 5 }}>
                  {msg}
                </p>
              ) : null}
              <div style={{ textAlign: 'center' }}>
                {isHideSubmitButton == false ? (
                  <Button
                    style={{ width: '40%', marginTop: 5, backgroundColor: '#1c65c9' }}
                    type="submit"
                    onClick={onsubmitform}
                    className="btn btn-primary "
                  >
                    Submit
                  </Button>
                ) : (
                  <p style={{ fontSize: 14, fontWeight: 'bold', color: 'green' }}>Please wait...</p>
                )}
                <div style={{ marginTop: 10 }}>
                  <span
                    style={{
                      fontSize: 18,
                      color: '#1c65c9',
                      paddingBottom: 10,
                      textDecoration: 'none',
                      cursor: 'pointer',
                    }}
                    onClick={goToLogin}
                  >
                    Go to Login{' '}
                  </span>
                </div>
              </div>
            </div>

            {isResetFunctionSectionOpen == false ? (
              <div className="page-ath-form" id="otp" style={myStyle_otp}>
                <div className="card-head">
                  <h6
                    className="card-title"
                    style={{
                      marginTop: 15,
                      marginLeft: 10,
                      fontWeight: 'bold',
                      textAlign: 'center',
                      paddingTop: 10,
                    }}
                  >
                    OTP
                  </h6>
                </div>
                <div style={{ textAlign: 'center' }} className="input-item input-with-label">
                  {isShowCurrentOTP == true ? (
                    <p style={{ marginTop: 15, marginLeft: 8 }}>Your current OTP is : {OTPValue}</p>
                  ) : (
                    <p style={{ textAlign: 'center' }}>
                      Enter OTP sent to your mobile XXXXXXX{contact_no.substr(-3)}{' '}
                    </p>
                  )}

                  {OTP.map((data, index) => {
                    return (
                      <input
                        className="otp-field"
                        type="tel"
                        name="otp"
                        maxLength="1"
                        key={index}
                        value={data}
                        style={{
                          height: 35,
                          width: 30,
                          paddingLeft: 10,
                          marginLeft: 10,
                          fontWeight: 'bold',
                          fontSize: 12,
                        }}
                        onChange={(event) => handleChange(event.target, index)}
                        onFocus={(e) => e.target.select()}
                      />
                    )
                  })}
                </div>
                {errorMessage && (
                  <div className="error">
                    {' '}
                    <p style={{ color: 'red', fontSize: 14, fontWeight: 'bold' }}>
                      {errorMessage}
                    </p>{' '}
                  </div>
                )}

                <br />
                <div style={{ textAlign: 'center' }} className="input-item input-with-label">
                  <a
                    type="submit"
                    onClick={onsubmitresend_otp}
                    className="resend"
                    style={{
                      fontSize: 15,
                      fontWeight: 'bold',
                      color: 'clue',
                      color: '#2c80ff',
                      textDecoration: 'none',
                    }}
                  >
                    RESEND OTP?
                  </a>
                </div>
                <div style={{ marginTop: 15, marginBottom: 10, textAlign: 'center' }}>
                  <Button
                    style={{ backgroundColor: '#2c80ff', marginBottom: 20 }}
                    type="submit"
                    onClick={onsubmitform_otp}
                    className="btn btn-primary"
                  >
                    Submit
                  </Button>
                </div>
              </div>
            ) : (
              <div className="page-ath-form" id="otp" style={myStyle_otp}>
                <div className="card-head">
                  <h6
                    className="card-title"
                    style={{
                      marginTop: 40,
                      textAlign: 'center',
                      fontSize: 20,
                      color: '#04066b',
                      paddingTop: 20,
                    }}
                  >
                    RESET PASSWORD
                  </h6>
                  <p style={{ textAlign: 'center', fontSize: 16 }}>
                    {localStorage.getItem('temp_user_id')}
                  </p>
                </div>

                <div style={{ textAlign: 'left', marginLeft: 30 }}>
                  <label
                    htmlFor="user_id"
                    className="col-form-label"
                    style={{ fontSize: 15, color: '#7781A9' }}
                  >
                    Password
                  </label>
                  <br />
                  <Input
                    style={{ width: '90%', marginBottom: 20 }}
                    type={showPassword ? 'text' : 'password'}
                    required
                    placeholder="Password"
                    value={password}
                    onChange={onPasswordChange}
                    maxLength={15}
                    suffix={
                      showPassword ? (
                        <EyeInvisibleOutlined
                          onClick={() => setShowPassword(false)}
                          style={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <EyeOutlined
                          onClick={() => setShowPassword(true)}
                          style={{ cursor: 'pointer' }}
                        />
                      )
                    }
                  />
                </div>

                <div style={{ textAlign: 'left', marginLeft: 30 }}>
                  <label
                    htmlFor="password"
                    className="col-form-label"
                    style={{ fontSize: 15, color: '#7781A9' }}
                  >
                    Confirm Password
                  </label>
                  <br />
                  <Input
                    style={{ width: '90%', marginBottom: 20 }}
                    type={showConfirmPassword ? 'text' : 'password'}
                    required
                    placeholder="Confirm Password"
                    value={confirm_password}
                    onChange={onConfirmPasswordChange}
                    maxLength={15}
                    suffix={
                      showConfirmPassword ? (
                        <EyeInvisibleOutlined
                          onClick={() => setShowConfirmPassword(false)}
                          style={{ cursor: 'pointer' }}
                        />
                      ) : (
                        <EyeOutlined
                          onClick={() => setShowConfirmPassword(true)}
                          style={{ cursor: 'pointer' }}
                        />
                      )
                    }
                  />
                </div>

                {errorMessage && (
                  <div className="error">
                    <p style={{ color: 'red', fontSize: 14, fontWeight: 'bold' }}>{errorMessage}</p>
                  </div>
                )}
                {successMessage && (
                  <div>
                    <p style={{ color: 'green', fontSize: 14, fontWeight: 'bold', marginTop: 15 }}>
                      {successMessage}
                    </p>
                  </div>
                )}

                <div style={{ textAlign: 'center' }}>
                  <Button
                    style={{ marginBottom: 30, backgroundColor: '#0f809a', color: 'white' }}
                    id="submitbutton"
                    type="primary"
                    onClick={onSubmitResetForm}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}